import React, { useContext } from 'react';
import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import type { AutomationTemplateContents } from '@reach/shared-types/automation-template';
import { AutomationEditorContext } from './AutomationEditorContext';
import { TriggerStep } from './trigger-step/TriggerStep';
import { SendMessageStep } from './send-message-step';
import { WaitStep } from './wait-step';
import { WaitUntilStep } from './wait-until-step';
import { CheckAudienceStep } from './check-audience-step';
import { AddStepButton } from './add-step-button';
import styles from './EditAutomationTemplate.module.css';

const { stepList } = styles;

const {
  SEND_COMMUNICATION,
  WAIT_FOR_DURATION,
  WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME,
  WAIT_UNTIL_NEXT_OCCURRENCE,
  CHECK_SEGMENT_MEMBERSHIP,
} = BusinessAutomationActionTypeEnum;

type ActionType = AutomationTemplateContents['actionData'][0]['type'];

type StepComponent = React.ComponentType<{ index: number }>;

const ACTION_TYPE_TO_COMPONENT: Record<ActionType, StepComponent> = {
  [SEND_COMMUNICATION]: SendMessageStep,
  [WAIT_FOR_DURATION]: WaitStep,
  [WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME]: WaitUntilStep,
  [WAIT_UNTIL_NEXT_OCCURRENCE]: WaitUntilStep,
  [CHECK_SEGMENT_MEMBERSHIP]: CheckAudienceStep,
};

export const AutomationEditor: React.FC = () => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state, addAction } = editor;

  const contents = state.localContents;
  const actions = contents.actionData || [];

  return (
    <div className={stepList}>
      <TriggerStep />

      {actions.map((action, index) => {
        const StepComponent = ACTION_TYPE_TO_COMPONENT[action.type];

        return (
          <React.Fragment key={action.templateActionId || index}>
            <AddStepButton
              onAddStep={(actionType: string) => addAction(actionType, index)}
              dropIndex={index}
            />
            {StepComponent && <StepComponent index={index} />}
          </React.Fragment>
        );
      })}

      <AddStepButton
        onAddStep={(actionType: string) =>
          addAction(actionType, actions.length)
        }
        isLast
        dropIndex={actions.length}
      />
    </div>
  );
};
